<template>
  <div class="search">
    <van-search 
      :placeholder="placeholder" 
      v-model="keyword" 
      shape="round"
      left-icon=""
      @search="onSearch">
    </van-search>
    <div class="list" v-show="(list && list.length) || loading">
      <van-loading v-if="loading"/>
      <van-cell-group v-if="!loading">
        <van-cell v-for="item in list" :title="item.name" @click="selectKeyword(item)">
          <template slot="default">
            <van-icon name="search" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div class="history" v-show="(!list || !list.length) && !loading">
      <van-cell title="最近搜索" value="" />
      <div class="content">
        <span class="tag" v-for="item in historyList" @click="selectHistory(item)">{{item}}</span>
      </div>
    </div>
  </div>
</template>

<script>

import {getSuggest} from '@/api/positions'
import {setStorage, getStorage} from '@/common/utils/storage'

export default {
  name: "search",
  props: {
    
  },
  data(){
    return {
      loading: false,
      keyword: this.$route.query.keyword || '',
      historyList: [],
      list: [],
      placeholder: this.$route.query.placeholder || '请输入职位/公司名/职位ID',
      from: this.$route.query.from || 'search'
    }
  },
  watch: {
    keyword(n,o){
      if(!n){
        this.list = [];
      }else{
        this.getList(n);
      }
    }
  },
  methods: {
    selectKeyword(item){
      this.list = [];
      this.onSearch(item.name);
    },
    onSearch(keyword){
      if(keyword && keyword.trim()){
          
        if(this.historyList.includes(keyword))
          this.historyList = this.historyList.filter(item=>item!=keyword);

        this.historyList.unshift(keyword);
        setStorage('historyList', this.historyList.slice(0,10));
      }

      if(keyword || this.keyword){
        this.$router.replace({name: this.from, query: {query: keyword || this.keyword}});
      }else{
        this.$router.replace({name: this.from});
      }
    },
    getList(keyword){
      getSuggest({type:1,limit:10,nature:1,word:keyword}).then(res=>{
        this.list = res.data || [];
      }).catch(err=>{})
    },
    selectHistory(item){
      this.onSearch(item);
    },
    init(){
      this.historyList = getStorage('historyList') || [];
    } 
  },
  created(){
    this.init();
  }
};

</script>


<style scoped lang="scss">
  .history{
    margin-top: 15px;
    .content{
      padding: 0 10px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .tag{
        cursor: default;
        padding: 8px 15px;
        margin-right: 10px;
        margin-top: 10px;
        background: #FFFFFF;
        border: 0.5px solid #E5E5E5;
        border-radius: 4px;
        font-size: 14px;
        color: #666666;
        text-align: center;
      }
    }
  }
</style>

<style lang="scss">
  .search{
    .van-search{
      padding: 7px 10px;
      .van-cell{
        padding: 3px 8px 3px 0;
      }
    }
    .van-dropdown-menu{
      height: 30px;
    }
    .van-dropdown-menu__title{
      .van-ellipsis{
        max-width: 30px;
      }
    }
    .van-search__label{
      padding: 0 15px 0 10px;
      margin-right: 10px;
      position: relative;
      line-height: 30px;
      &:after{
        content: " ";
        position: absolute;
        right: 0;
        top: 50%;
        width: 1px;
        height: 40%;
        background-color: #e5e5e5;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
      };
    }
    .van-tree-select__item{
      .van-icon-checked{
        display: none;
      }
    }
  }
</style>
